import * as React from "react"
import { CategorySubtype } from "@digits-graphql/frontend/graphql-bearer"
import { CategoryType, Flow, ReportKind } from "@digits-graphql/frontend/graphql-public"
import { buildZeroMoneyFlow } from "@digits-shared/helpers/moneyFlowHelper"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import {
  SectionSummaryTitle,
  sectionTitleColor,
} from "src/frontend/components/Shared/Layout/Components/Statements/shared"
import { useStatementKind } from "src/frontend/components/Shared/Layout/Components/Statements/StatementContext"
import {
  Amount,
  RowWithDetails,
} from "src/frontend/components/Shared/Layout/Components/Statements/StatementRowShared"
import { type CondensedAgingSummaryProps } from "src/frontend/components/Shared/Layout/Components/Statements/StatementRowShared"

const CondensedSectionSummaryText = styled.div`
  margin-bottom: 5px;
  text-align: right;
`

const CondensedSectionSummaryContainer = styled.div`
  margin-bottom: 5px;
  ${sectionTitleColor};
  font-weight: ${fonts.weight.medium};
  display: flex;
  grid-column: span 2;
`

const CondensedSectionSummaryTitle = styled(SectionSummaryTitle)`
  text-transform: unset;
  padding-left: 0;
`

const CondensedAgingSectionSummaryRow = styled(RowWithDetails)`
  display: flex;
  justify-content: space-between;
`

export const CondensedAgingSectionSummary: React.FC<CondensedAgingSummaryProps> = ({
  id,
  depth,
  summary: { label, dimensionSummary },
  details,
}) => {
  const kind = useStatementKind()

  const hoverDetails = details?.periodDetails?.hover
    ? details
    : {
        periodDetails: {
          hover: {
            entity: {
              active: true,
              displayKey: "1",
              id: "category-uuid",
              name: "Category",
              subtype: CategorySubtype.AccountsPayable,
              type: CategoryType.Expenses,
            },
            history: dimensionSummary,
          },
        },
      }

  return (
    <CondensedAgingSectionSummaryRow id={id} depth={depth} details={hoverDetails}>
      <CondensedSectionSummaryContainer>
        <CondensedSectionSummaryTitle>{label.replace("Total ", "")}</CondensedSectionSummaryTitle>
      </CondensedSectionSummaryContainer>
      <CondensedSectionSummaryText data-context-id={id}>
        <Amount
          rowId={id}
          moneyFlow={
            dimensionSummary.summary.total.current?.total ??
            buildZeroMoneyFlow(kind === ReportKind.APAging ? Flow.Outbound : Flow.Inbound)
          }
        />
      </CondensedSectionSummaryText>
    </CondensedAgingSectionSummaryRow>
  )
}
